<template>
  <div class="def-card-control">
    <span
      v-if="screenWidth >= 768"
      class="def-card-control__item"
      :class="{ 'def-card-control__item_active': productListCardType === 1 }"
      @click="changeProductListCardType(1)"
    >
      <svg class="def-card-control__icon">
        <use xlink:href="#svg-col-4"></use>
      </svg>
    </span>

    <span
      v-if="screenWidth >= 768"
      class="def-card-control__item"
      :class="{ 'def-card-control__item_active': productListCardType === 2 }"
      @click="changeProductListCardType(2)"
    >
      <svg class="def-card-control__icon">
        <use xlink:href="#svg-col-5"></use>
      </svg>
    </span>
    <span
      v-if="screenWidth < 768"
      class="def-card-control__item def-card-control__item_active"
      @click="changeProductListCardType(productListCardType === 1 ? 2 : 1)"
    >
      <svg class="def-card-control__icon">
        <use v-if="productListCardType === 1" xlink:href="#svg-col-2"></use>
        <use v-else xlink:href="#svg-col-1"></use>
      </svg>
    </span>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import useScreenWidth from '@use/useScreenWidth';

export default {
  name: 'DefCardControl',
  props: ['result'],
  data() {
    return {
      screenWidth: useScreenWidth(),
    };
  },
  computed: {
    ...mapState({
      productListCardType: ({ catalog }) => catalog.data.productListCardType,
    }),
  },
  methods: {
    ...mapMutations({
      changeProductListCardType: 'catalog/changeProductListCardType',
    }),
  },
};
</script>

<style lang="scss" scoped>
.def-card-control {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 24px;
  margin-left: 16px;
  @include point-md {
    grid-column-gap: 8px;
  }
  &__item {
    cursor: pointer;
    padding: 4px;
    transition: 0.2s linear background-color;
    @include point-md {
      padding: 8px;
    }
    &_active {
      background-color: rgba(61, 61, 81, 0.1);
      svg {
        fill: #3d3d51;
      }
    }
  }
  &__icon {
    display: block;
    width: 24px;
    height: 24px;
    fill: var(--background-dark-grey);
    transition: 0.2s linear fill;
  }
}
</style>
